import * as M from '@mantine/core';
import { IconFiles, IconTextPlus } from '@tabler/icons-react';
import { queryClient } from '../../../../../../shared/queryClient';
import { useNavigate } from 'react-router-dom';
import { deviceApis } from '../../../../../../shared/apis/device/apis';
import Swal from 'sweetalert2';
import { showNotification } from '@mantine/notifications';
import { showSuccessNotification } from '../../../../../ui/notification';
import { queries } from '../../../../../../shared/queries';
import useDeleteDevice from '../../common/hooks/useDeleteDevice';

interface IPropsDeviceRegister {
  checkBoxArr: string[];
  resetCheckBoxArr: () => void;
  open: () => void;
}

export default function DeviceRegister(props: IPropsDeviceRegister) {
  const { checkBoxArr, resetCheckBoxArr, open } = props;

  const navigate = useNavigate();
  const { mutate } = useDeleteDevice();

  const onClickDelete = () => {
    if (checkBoxArr.length === 0) {
      Swal.fire({
        title: '삭제할 디바이스를 선택해주세요.',
        icon: 'warning',
        confirmButtonText: '확인',
      });
      return;
    }

    Swal.fire({
      title: '디바이스를 삭제하시겠습니까?',
      text: '타 서비스에서 사용 중인 디바이스는 삭제할 수 없습니다.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '확인',
      cancelButtonText: '취소',
    }).then((result) => {
      if (result.isConfirmed) {
        mutate(checkBoxArr, {
          onSuccess: () => {
            showNotification({
              title: '디바이스 삭제 완료',
              message: '선택한 디바이스가 삭제되었습니다.',
              color: 'green',
              autoClose: 2000,
            });
            queryClient.invalidateQueries(queries.devices.list._def);
            resetCheckBoxArr();
          },
        });
      }
    });
  };

  const getListExcelDownload = async () => {
    try {
      showSuccessNotification('엑셀 다운로드를 시작했습니다.', '잠시만 기다려주세요.');
      // TODO: UI 개선 필요 - 다운로드 개수 혹은 기한 등을 제한하는 방안 고려
      const res = await deviceApis.management.getDeviceListExcelDownload({ page: 1, size: 100000 });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', '디바이스 목록.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: '엑셀 다운로드 실패',
        text: '엑셀 다운로드에 실패했습니다.',
        confirmButtonText: '확인',
      });
    }
  };

  return (
    <M.Group gap="xs">
      <M.Menu shadow="md" width={114} position="bottom">
        <M.Menu.Target>
          <M.Button variant="filled" color="secondary.5">
            등록
          </M.Button>
        </M.Menu.Target>
        <M.Menu.Dropdown>
          <M.Menu.Item
            fw="normal"
            leftSection={<IconTextPlus size={18} />}
            onClick={() => navigate('/admin/management/device/register')}
          >
            개별 등록
          </M.Menu.Item>
          <M.Menu.Item fw="normal" leftSection={<IconFiles size={18} />} onClick={open}>
            엑셀 등록
          </M.Menu.Item>
        </M.Menu.Dropdown>
      </M.Menu>
      <M.Button variant="outline" onClick={onClickDelete} disabled={checkBoxArr.length === 0}>
        선택 삭제
      </M.Button>
      <M.Button variant="default" onClick={getListExcelDownload}>
        엑셀 다운로드
      </M.Button>
    </M.Group>
  );
}
